"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionDataset = void 0;
const interfaces_1 = require("@buildcore/interfaces");
const Dataset_1 = require("./Dataset");
/**
 * Auction dataset to read and trigger POST actions against the API
 */
class AuctionDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        /**
         * Create generic Auction.
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link AuctionCreateRequest}
         * @returns
         */
        this.create = (req) => this.sendRequest(interfaces_1.WEN_FUNC.createauction)(req);
        /**
         * Bid on auction.
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link AuctionBidRequest}
         * @returns
         */
        this.bid = (req) => this.sendRequest(interfaces_1.WEN_FUNC.bidAuction)(req);
    }
}
exports.AuctionDataset = AuctionDataset;
